export default __webpack_public_path__ + "static/media/מועמדים-פוטושופ---סופי_0001s_0000_Black-&-White-20.b2ad3de7.png";